import axios from 'axios'
import AxiosRequestManager from './axiosRequestManager'
import LoginUtils from '@/core/utils/login-utils'

const requestManager = new AxiosRequestManager({ debug: false })

const api = axios.create({
  baseURL: process.env.VUE_APP_URL_API_AGENDA
})

api.interceptors.request.use(config => {
  let token = LoginUtils.getToken()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

api.interceptors.response.use(response => response, error => {
  if (error.response){
    if(error.response.status == 401){
      LoginUtils.logout()
      console.log(error)
    }
    
    throw error
  }
})

export const AxiosConfigApiAgenda = {

  cancelAll: function () {
    requestManager.cancelAllRequests()
  },

  isCancelled: function (error) {
    return axios.isCancel(error)
  },

  api: function () {
    return api
  },
}

export default AxiosConfigApiAgenda
